// src/data/formData.js
export const hotelTypes = [
    'Luxury Hotel', 'Boutique Hotel', 'Resort Hotel', 'Budget Hotel',
    'Business Hotel', 'Airport Hotel', 'Eco-friendly Hotel', 'All-Inclusive Resort',
    'Historic Hotel', 'Casino Hotel', 'Glamping Hotel', 'Floating Hotel',
    'Safari Hotel', 'Golf Resorts', 'Wellness Hotel', 'Heritage Hotel',
    'Beach Hotel', 'Others'
];

export const hotelViews = [
    'Creek', 'River', 'Lake', 'Meadow/Field', 'Desert', 'Ocean',
    'Mountain', 'Forest', 'Vineyard', 'Valley', 'Cliffside', 'Island',
    'Sunset/Sunrise', 'Cityscape', 'Skyline', 'Garden', 'Golf Course',
    'Landscaped Grounds', 'Park', 'Courtyard', 'Countryside', 'Trails',
    'Harbor', 'Waterfall', 'Waterfront', 'Ravine', 'Glacier', 'Tundra',
    'Wetlands', 'Marsh', 'Pond', 'Canyon', 'Marine', 'Boardwalk',
    'Promenade', 'Rooftop', 'Stadium', 'Amusement Park', 'Plaza',
    'Historical District', 'Pedestrian Street', 'Waterfront Park'
];

export const hotelStyles = {
    traditional: [
        'Colonial', 'Spanish', 'Victorian', 'Gothic Revival', 'Tudor',
        'French Country', 'Mediterranean', 'Farmhouse', 'Georgian', 'Federal',
        'Cape Cod', 'Bungalow', 'Arts & Crafts', 'Arts Nouveau'
    ],
    modern: [
        'Minimalist', 'Contemporary', 'Modern', 'Mid-Century Modern', 'Scandinavian',
        'Industrial', 'Brutalism', 'Postmodernism', 'Deconstructivism', 'High-tech', 'Parametricism'
    ],
    eclectic: [
        'Eclectic', 'Bohemian', 'Art Deco', 'Shabby Chic', 'Retro',
        'Fusion', 'Global'
    ],
    cultural: [
        'Asian Fusion', 'Chinese Traditional', 'Japanese Traditional', 'Balinese',
        'Thai', 'Korean Hanok', 'Indian Traditional', 'Tibetan', 'Southeast Asian',
        'Filipino Bahay Kubo', 'Vietnamese Colonial', 'Malaysian Malay',
        'Singaporean Peranakan', 'Indonesian Javanese', 'Mongolian Ger', 'Moroccan',
        'Persian/Iranian', 'African Tribal', 'Maori', 'Mexican'
    ]
};
